import { endOfDay, startOfDay, subDays } from 'date-fns';

import { DateRange, DateRangePeriod } from '../config/types';

export const getDateRange = (period: DateRangePeriod): DateRange => {
  const now = new Date();

  switch (period) {
    case 'today':
      return {
        from: startOfDay(now),
        to: endOfDay(now),
      };
    case 'week':
      return {
        from: startOfDay(subDays(now, 7)),
        to: endOfDay(now),
      };
    case 'custom':
    case 'all':
    default:
      return { from: undefined, to: undefined };
  }
};
